import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap, catchError, throwError } from 'rxjs';
import { isApiRequest, RUNTIME_CONFIG } from '../config/runtime-config';
import { KeycloakSessionService } from './auth/keycloak-session.service';

export const getTokenInterceptor: HttpInterceptorFn = (request, next) => {
  const session = inject(KeycloakSessionService);
  const config = inject(RUNTIME_CONFIG);
  if (
    !isApiRequest(
      request.url,
      [
        session.realmUrl + '/account',
        session.iamUrl,
        session.adminUrl,
        config.notificationApiUrl,
        config.auditApiUrl,
        config.backendApiUrl,
      ],
      location.origin,
    ) ||
    !session.authenticated
  )
    return next(request);
  return from(session.accessToken()).pipe(
    switchMap((token) =>
      next(
        request.clone({ setHeaders: { Authorization: `Bearer ${token}` } }),
      ).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status !== 401) return throwError(() => error);
          return from(session.accessToken(session.token === token)).pipe(
            switchMap((refreshed) =>
              next(
                request.clone({
                  setHeaders: { Authorization: `Bearer ${refreshed}` },
                }),
              ),
            ),
          );
        }),
      ),
    ),
  );
};
